<template>
  <!-- <div v-html="content" /> -->
  <div :style="imgStyle">
    <img :src="imgSrc" />
  </div>
</template>

<script>
import axios from 'axios'
import config from '@/config'

export default {
  name: 'image-only',
  version: '0.0.1',
  props: {
    contentKey: {
      type: String,
      required: true
    },
    imgAlign: {
      type: String,
      default: 'start',
      validator: (v) => ['start', 'center', 'end'].includes(v)
    }
  },
  data () {
    return {
      content: '... loading content!',
      imgSrc: '', // TODO: introduce loading_image default image
      imgStyle: {
        textAlign: this.imgAlign
      }
    }
  }, // data
  async mounted () {
    try {
      // const resp = await axios.get(config.glapiBaseUri + '/content/byContentKey/' +
      //   this.contentKey + '/toHtml')
      const resp = await axios.get(config.glapiBaseUri + '/content/byContentKey/' +
        this.contentKey)
      // this.content = resp.data
      this.imgSrc = resp.data.payload.content.fragments.imgUrl
      console.log('TRACE-REMOVE: ImageOnly: resp is: ', resp)
    } catch (e) {
      // TODO: error handling
      this.content = 'Error loading the content!'
      console.error('ERROR: Exception is: ', e)
    }
  }
}
</script>

<style scoped>
</style>
